export const vulnerabilityPosts = [
  {
    id: 'v1',
    user_id: 'user1',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'CVE-2025-0282: Ivanti Connect Secure 제로데이 RCE 긴급 패치',
    content: 'Ivanti Connect Secure VPN에서 인증 없이 원격 코드 실행이 가능한 스택 오버플로우 취약점이 발견됐습니다. CVSS 9.0으로 이미 실제 공격에 악용되고 있으며, 특히 정부기관과 금융권을 타겟으로 한 APT 그룹의 활동이 포착됐습니다. 즉시 22.7.3.5 이상으로 업그레이드 필요합니다.',
    tags: ['ivanti', 'zero-day', 'cve-2025', 'vpn', 'critical'],
    status: 'open',
    is_pinned: true,
    likes_count: 1243,
    replies_count: 47,
    views_count: 9820,
    created_at: new Date(Date.now() - 18 * 60000).toISOString(),
    profiles: {
      id: 'user1',
      username: 'ghost_0x7f',
      display_name: 'Ghost Security',
      points: 15420,
      reputation: 4850
    }
  },
  {
    id: 'v2',
    user_id: 'user2',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'DeepSeek AI 서버에서 100만 건 대화 기록 무인증 노출 발견',
    content: 'DeepSeek의 ClickHouse 데이터베이스가 인터넷에 완전히 노출되어 있었습니다. API 키, 백엔드 로그, 사용자 채팅 기록 등이 인증 없이 접근 가능했으며, 심지어 시스템 내부 명령 실행도 가능한 상태였습니다. Wiz Research 팀이 발견 후 즉시 신고했고 현재는 패치됐습니다.',
    tags: ['deepseek', 'ai-security', 'data-breach', 'clickhouse'],
    status: 'open',
    is_pinned: true,
    likes_count: 2891,
    replies_count: 83,
    views_count: 24500,
    created_at: new Date(Date.now() - 52 * 60000).toISOString(),
    profiles: {
      id: 'user2',
      username: 'cipher_master',
      display_name: 'Cipher Master',
      points: 12890,
      reputation: 3920
    }
  },
  {
    id: 'v3',
    user_id: 'user3',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Windows NTLM Hash 릴레이 공격 신규 기법 - PetitPotam 변종',
    content: 'Active Directory 환경에서 NTLM 릴레이 공격의 새로운 변종을 분석했습니다. MS-EFSRPC를 통한 강제 인증 유도 후 LDAP 릴레이로 도메인 컨트롤러 권한 탈취까지 전 과정을 PoC와 함께 공개합니다. Impacket ntlmrelayx 활용법도 포함했습니다.',
    tags: ['ntlm', 'active-directory', 'relay-attack', 'windows', 'poc'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 62,
    views_count: 11340,
    created_at: new Date(Date.now() - 2.5 * 3600000).toISOString(),
    profiles: {
      id: 'user3',
      username: 'exploit_dev',
      display_name: 'Exploit Developer',
      points: 11234,
      reputation: 4120
    }
  },
  {
    id: 'v4',
    user_id: 'user10',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'macOS Sequoia 15.3 커널 취약점 - 로컬 권한 상승 PoC 공개',
    content: 'macOS Sequoia 15.3 이하 버전에서 IOKit 드라이버의 use-after-free 취약점을 발견했습니다. 일반 사용자 권한에서 커널 코드 실행이 가능하며, SIP(System Integrity Protection) 우회까지 연계됩니다. Apple에 90일 전 신고했고 15.3.1 패치가 배포됐습니다. PoC 코드를 공개합니다.',
    tags: ['macos', 'kernel', 'privilege-escalation', 'iokit', 'apple'],
    status: 'open',
    is_pinned: false,
    likes_count: 2340,
    replies_count: 88,
    views_count: 19800,
    created_at: new Date(Date.now() - 3 * 3600000).toISOString(),
    profiles: {
      id: 'user10',
      username: 'mac_pwner',
      display_name: 'Mac Pwner',
      points: 14560,
      reputation: 4320
    }
  },
  {
    id: 'v5',
    user_id: 'user5',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Kubernetes RBAC 잘못된 설정으로 클러스터 전체 탈취 - 실전 케이스',
    content: '실제 침투 테스트에서 발견한 K8s RBAC 설정 오류 사례입니다. wildcard(*) 권한이 부여된 ServiceAccount를 통해 secrets 전체 열람 → 다른 네임스페이스 pod exec → 노드 탈출까지 전 과정을 재현했습니다. 안전한 RBAC 설정 가이드라인도 함께 정리했습니다.',
    tags: ['kubernetes', 'rbac', 'container-escape', 'cloud-security', 'k8s'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 44,
    views_count: 13200,
    created_at: new Date(Date.now() - 4 * 3600000).toISOString(),
    profiles: {
      id: 'user5',
      username: 'cloud_hunter',
      display_name: 'Cloud Hunter',
      points: 9840,
      reputation: 2890
    }
  },
  {
    id: 'v6',
    user_id: 'user11',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Apache Struts2 S2-067 RCE 취약점 분석 및 탐지 방법',
    content: 'Struts2의 OGNL 표현식 처리 과정에서 발견된 새로운 RCE 취약점입니다. 2.5.33 이하 버전이 영향받으며, Content-Type 헤더 조작만으로 원격 코드 실행이 가능합니다. 실제 공격 시나리오와 WAF 우회 기법, 그리고 효과적인 탐지 룰을 공유합니다.',
    tags: ['struts2', 'rce', 'ognl', 'java', 'web'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 53,
    views_count: 10200,
    created_at: new Date(Date.now() - 5 * 3600000).toISOString(),
    profiles: {
      id: 'user11',
      username: 'java_hunter',
      display_name: 'Java Hunter',
      points: 10340,
      reputation: 3210
    }
  },
  {
    id: 'v7',
    user_id: 'user12',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'GitLab CI/CD 파이프라인 권한 상승 취약점 (CVE-2025-1234)',
    content: 'GitLab 16.8 이하에서 CI/CD 변수 마스킹 우회를 통한 권한 상승 취약점을 발견했습니다. protected 브랜치 제한을 우회하여 프로덕션 환경의 시크릿 키를 탈취할 수 있습니다. 16.9.1 패치 적용과 함께 CI/CD 보안 설정 점검이 필요합니다.',
    tags: ['gitlab', 'cicd', 'privilege-escalation', 'devops'],
    status: 'open',
    is_pinned: false,
    likes_count: 987,
    replies_count: 38,
    views_count: 7650,
    created_at: new Date(Date.now() - 6 * 3600000).toISOString(),
    profiles: {
      id: 'user12',
      username: 'devops_sec',
      display_name: 'DevOps Security',
      points: 8920,
      reputation: 2560
    }
  },
  {
    id: 'v8',
    user_id: 'user13',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'PostgreSQL 16.x 인증 우회 취약점 - 로컬 공격 시나리오',
    content: 'PostgreSQL 16.0~16.2 버전에서 특정 조건 하에 인증을 우회할 수 있는 취약점이 발견됐습니다. peer 인증 방식 사용 시 Unix 소켓을 통한 권한 상승이 가능하며, 컨테이너 환경에서 특히 위험합니다. 16.3 업데이트와 pg_hba.conf 재설정이 필요합니다.',
    tags: ['postgresql', 'authentication-bypass', 'database', 'container'],
    status: 'open',
    is_pinned: false,
    likes_count: 1123,
    replies_count: 41,
    views_count: 8340,
    created_at: new Date(Date.now() - 8 * 3600000).toISOString(),
    profiles: {
      id: 'user13',
      username: 'db_guardian',
      display_name: 'DB Guardian',
      points: 9560,
      reputation: 2890
    }
  },
  {
    id: 'v9',
    user_id: 'user14',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Cisco IOS XE 웹 UI 제로데이 - 백도어 계정 생성 공격 분석',
    content: 'Cisco IOS XE 웹 관리 인터페이스에서 인증 우회 후 최고 권한 계정을 생성하는 제로데이 공격이 야생에서 발견됐습니다. 이미 10,000대 이상의 라우터가 감염된 것으로 추정되며, 특정 URI 패턴으로 탐지 가능합니다. 즉시 웹 UI 비활성화가 권장됩니다.',
    tags: ['cisco', 'ios-xe', 'zero-day', 'backdoor', 'network'],
    status: 'open',
    is_pinned: false,
    likes_count: 1876,
    replies_count: 67,
    views_count: 14500,
    created_at: new Date(Date.now() - 10 * 3600000).toISOString(),
    profiles: {
      id: 'user14',
      username: 'net_sec_pro',
      display_name: 'Network Security Pro',
      points: 11230,
      reputation: 3450
    }
  },
  {
    id: 'v10',
    user_id: 'user15',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Spring Framework SpEL Injection 신규 우회 기법 공개',
    content: 'Spring Framework의 SpEL(Spring Expression Language) 인젝션 취약점에 대한 새로운 우회 기법을 발견했습니다. 기존 블랙리스트 필터를 우회하여 Runtime.getRuntime().exec() 실행이 가능하며, 실제 프로덕션 환경에서 테스트한 페이로드를 공유합니다.',
    tags: ['spring', 'spel-injection', 'java', 'bypass', 'rce'],
    status: 'open',
    is_pinned: false,
    likes_count: 1654,
    replies_count: 59,
    views_count: 11800,
    created_at: new Date(Date.now() - 12 * 3600000).toISOString(),
    profiles: {
      id: 'user15',
      username: 'spring_pwner',
      display_name: 'Spring Pwner',
      points: 10890,
      reputation: 3340
    }
  },
  {
    id: 'v11',
    user_id: 'user16',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'AWS Lambda 함수 URL 인증 우회 - 실전 공격 사례',
    content: 'AWS Lambda 함수 URL의 IAM 인증 설정 오류로 인한 무단 접근 사례를 분석했습니다. CORS 설정과 결합하여 크로스 오리진에서 민감한 데이터를 탈취할 수 있었으며, 실제 금융 서비스에서 발견한 케이스입니다. 안전한 Lambda 함수 URL 설정 가이드를 제공합니다.',
    tags: ['aws', 'lambda', 'serverless', 'authentication', 'cloud'],
    status: 'open',
    is_pinned: false,
    likes_count: 1342,
    replies_count: 48,
    views_count: 9870,
    created_at: new Date(Date.now() - 14 * 3600000).toISOString(),
    profiles: {
      id: 'user16',
      username: 'cloud_breaker',
      display_name: 'Cloud Breaker',
      points: 12450,
      reputation: 3780
    }
  },
  {
    id: 'v12',
    user_id: 'user17',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'WordPress Elementor Pro 플러그인 SQL Injection (CVE-2025-5678)',
    content: 'Elementor Pro 3.19 이하 버전에서 인증된 사용자가 SQL Injection을 수행할 수 있는 취약점이 발견됐습니다. Subscriber 권한만으로도 전체 데이터베이스 덤프가 가능하며, 500만 개 이상의 사이트가 영향받습니다. 즉시 3.20 업데이트가 필요합니다.',
    tags: ['wordpress', 'elementor', 'sqli', 'cms', 'plugin'],
    status: 'open',
    is_pinned: false,
    likes_count: 2134,
    replies_count: 76,
    views_count: 16700,
    created_at: new Date(Date.now() - 16 * 3600000).toISOString(),
    profiles: {
      id: 'user17',
      username: 'wp_security',
      display_name: 'WP Security Expert',
      points: 9780,
      reputation: 2910
    }
  },
  {
    id: 'v13',
    user_id: 'user18',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Android 14 Bluetooth 스택 메모리 손상 취약점 분석',
    content: 'Android 14의 Bluetooth 스택에서 힙 오버플로우 취약점을 발견했습니다. 페어링된 기기로부터 악의적인 패킷을 받으면 system_server 프로세스가 크래시되며, 특정 조건에서 코드 실행도 가능합니다. 2025년 3월 보안 패치에 포함될 예정입니다.',
    tags: ['android', 'bluetooth', 'heap-overflow', 'mobile', 'exploit'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 52,
    views_count: 11200,
    created_at: new Date(Date.now() - 18 * 3600000).toISOString(),
    profiles: {
      id: 'user18',
      username: 'mobile_hacker',
      display_name: 'Mobile Hacker',
      points: 11670,
      reputation: 3560
    }
  },
  {
    id: 'v14',
    user_id: 'user19',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Redis 7.x Lua 샌드박스 탈출 - 원격 코드 실행 PoC',
    content: 'Redis 7.0~7.2 버전의 Lua 스크립트 샌드박스를 탈출하여 호스트 시스템에서 임의 명령을 실행할 수 있는 취약점입니다. EVAL 명령을 통해 특수하게 조작된 Lua 코드를 실행하면 샌드박스 제한을 우회할 수 있습니다. 7.2.4 패치가 배포됐습니다.',
    tags: ['redis', 'lua', 'sandbox-escape', 'rce', 'database'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 64,
    views_count: 13400,
    created_at: new Date(Date.now() - 20 * 3600000).toISOString(),
    profiles: {
      id: 'user19',
      username: 'cache_pwner',
      display_name: 'Cache Pwner',
      points: 10230,
      reputation: 3120
    }
  },
  {
    id: 'v15',
    user_id: 'user20',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'VMware ESXi 8.0 호스트 탈출 취약점 - 게스트에서 호스트로',
    content: 'VMware ESXi 8.0의 USB 컨트롤러 에뮬레이션에서 발견된 취약점으로 게스트 VM에서 호스트 ESXi로 탈출할 수 있습니다. VMCI 소켓을 악용하여 하이퍼바이저 메모리에 접근 가능하며, 전체 가상화 인프라가 위험에 노출됩니다. 긴급 패치 적용이 필요합니다.',
    tags: ['vmware', 'esxi', 'vm-escape', 'hypervisor', 'virtualization'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 91,
    views_count: 18900,
    created_at: new Date(Date.now() - 22 * 3600000).toISOString(),
    profiles: {
      id: 'user20',
      username: 'vm_breaker',
      display_name: 'VM Breaker',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 'v16',
    user_id: 'user21',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'OpenSSH 9.6 사전 인증 RCE 취약점 - regreSSHion 분석',
    content: 'OpenSSH 9.6p1 이하 버전에서 인증 전 단계에서 원격 코드 실행이 가능한 치명적인 취약점이 발견됐습니다. glibc 기반 Linux 시스템이 주요 타겟이며, 32비트 시스템에서는 공격 성공률이 매우 높습니다. 즉시 9.7p1 이상으로 업그레이드해야 합니다.',
    tags: ['openssh', 'rce', 'pre-auth', 'linux', 'critical'],
    status: 'open',
    is_pinned: false,
    likes_count: 3124,
    replies_count: 108,
    views_count: 25600,
    created_at: new Date(Date.now() - 24 * 3600000).toISOString(),
    profiles: {
      id: 'user21',
      username: 'ssh_master',
      display_name: 'SSH Master',
      points: 15670,
      reputation: 4890
    }
  },
  {
    id: 'v17',
    user_id: 'user22',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Microsoft Exchange Server SSRF to RCE 체인 공격',
    content: 'Exchange Server 2019의 Autodiscover 기능에서 SSRF 취약점을 발견하고, 이를 통해 내부 API에 접근하여 최종적으로 RCE까지 연계하는 공격 체인을 구성했습니다. ProxyShell과 유사하지만 다른 벡터를 사용하며, 2025년 2월 패치에서 수정됐습니다.',
    tags: ['exchange', 'ssrf', 'rce', 'microsoft', 'chain'],
    status: 'open',
    is_pinned: false,
    likes_count: 1987,
    replies_count: 73,
    views_count: 14800,
    created_at: new Date(Date.now() - 26 * 3600000).toISOString(),
    profiles: {
      id: 'user22',
      username: 'exchange_hunter',
      display_name: 'Exchange Hunter',
      points: 12340,
      reputation: 3670
    }
  },
  {
    id: 'v18',
    user_id: 'user23',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Nginx 1.24.x HTTP/2 Rapid Reset 변종 공격 분석',
    content: 'Nginx 1.24 버전에서 HTTP/2 Rapid Reset 공격의 새로운 변종을 발견했습니다. 기존 패치를 우회하여 여전히 서비스 거부 공격이 가능하며, 특정 설정에서는 메모리 고갈까지 유발합니다. 1.25.3 업데이트와 함께 http2_max_concurrent_streams 조정이 필요합니다.',
    tags: ['nginx', 'http2', 'dos', 'rapid-reset', 'web-server'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 55,
    views_count: 10300,
    created_at: new Date(Date.now() - 28 * 3600000).toISOString(),
    profiles: {
      id: 'user23',
      username: 'web_defender',
      display_name: 'Web Defender',
      points: 9890,
      reputation: 2980
    }
  },
  {
    id: 'v19',
    user_id: 'user24',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Fortinet FortiOS SSL VPN 힙 오버플로우 - 야생 공격 확인',
    content: 'FortiOS 7.4.2 이하 버전의 SSL VPN 기능에서 힙 오버플로우 취약점이 발견됐으며, 이미 중국 APT 그룹이 실제 공격에 활용하고 있습니다. 인증 없이 원격 코드 실행이 가능하며, 전 세계 15만 대 이상의 FortiGate 장비가 노출되어 있습니다.',
    tags: ['fortinet', 'fortios', 'heap-overflow', 'vpn', 'apt'],
    status: 'open',
    is_pinned: false,
    likes_count: 2678,
    replies_count: 94,
    views_count: 21300,
    created_at: new Date(Date.now() - 30 * 3600000).toISOString(),
    profiles: {
      id: 'user24',
      username: 'firewall_pwner',
      display_name: 'Firewall Pwner',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 'v20',
    user_id: 'user25',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Django 5.0 ORM SQL Injection 우회 기법',
    content: 'Django 5.0의 ORM에서 특정 조건 하에 SQL Injection이 가능한 케이스를 발견했습니다. extra() 메서드와 raw SQL을 조합할 때 파라미터 바인딩이 제대로 작동하지 않는 엣지 케이스이며, 실제 프로덕션 코드에서 발견한 사례를 바탕으로 분석했습니다.',
    tags: ['django', 'orm', 'sqli', 'python', 'web'],
    status: 'open',
    is_pinned: false,
    likes_count: 1234,
    replies_count: 46,
    views_count: 8900,
    created_at: new Date(Date.now() - 32 * 3600000).toISOString(),
    profiles: {
      id: 'user25',
      username: 'python_sec',
      display_name: 'Python Security',
      points: 10560,
      reputation: 3210
    }
  },
  {
    id: 'v21',
    user_id: 'user26',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Azure AD Connect 동기화 계정 권한 상승 취약점',
    content: 'Azure AD Connect의 동기화 계정이 과도한 권한을 가지고 있어 이를 악용한 권한 상승 공격이 가능합니다. 온프레미스 AD를 장악한 공격자가 Azure AD의 Global Admin 권한을 획득할 수 있으며, 하이브리드 환경에서 매우 위험합니다. 완화 방법을 공유합니다.',
    tags: ['azure-ad', 'privilege-escalation', 'hybrid', 'cloud', 'microsoft'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 58,
    views_count: 11700,
    created_at: new Date(Date.now() - 34 * 3600000).toISOString(),
    profiles: {
      id: 'user26',
      username: 'azure_hunter',
      display_name: 'Azure Hunter',
      points: 11890,
      reputation: 3560
    }
  },
  {
    id: 'v22',
    user_id: 'user27',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Linux Kernel eBPF Verifier 우회 - 로컬 권한 상승',
    content: 'Linux Kernel 6.7 이하 버전의 eBPF verifier에서 타입 혼동 취약점을 발견했습니다. 일반 사용자가 특수하게 조작된 eBPF 프로그램을 로드하여 커널 메모리를 읽고 쓸 수 있으며, 최종적으로 root 권한 획득이 가능합니다. 6.8 커널에서 수정됐습니다.',
    tags: ['linux', 'kernel', 'ebpf', 'privilege-escalation', 'verifier'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 79,
    views_count: 16400,
    created_at: new Date(Date.now() - 36 * 3600000).toISOString(),
    profiles: {
      id: 'user27',
      username: 'kernel_dev',
      display_name: 'Kernel Developer',
      points: 16780,
      reputation: 5120
    }
  },
  {
    id: 'v23',
    user_id: 'user28',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'SAP NetWeaver 인증 우회 - 관리자 권한 탈취',
    content: 'SAP NetWeaver 7.5의 ICM(Internet Communication Manager)에서 인증 우회 취약점을 발견했습니다. 특정 HTTP 헤더 조작으로 인증을 우회하고 관리자 권한으로 시스템에 접근할 수 있습니다. 대규모 기업 ERP 시스템이 위험에 노출되어 있습니다.',
    tags: ['sap', 'netweaver', 'authentication-bypass', 'erp', 'enterprise'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 63,
    views_count: 13200,
    created_at: new Date(Date.now() - 38 * 3600000).toISOString(),
    profiles: {
      id: 'user28',
      username: 'erp_hacker',
      display_name: 'ERP Hacker',
      points: 12450,
      reputation: 3780
    }
  },
  {
    id: 'v24',
    user_id: 'user29',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'GraphQL 인트로스펙션 악용 - 숨겨진 API 엔드포인트 발견',
    content: '프로덕션 환경에서 인트로스펙션이 활성화된 GraphQL API를 통해 문서화되지 않은 민감한 엔드포인트를 발견하는 방법론을 정리했습니다. 실제 버그바운티에서 발견한 케이스를 바탕으로 자동화 스크립트와 함께 공유합니다. IDOR과 결합하면 매우 위험합니다.',
    tags: ['graphql', 'introspection', 'api-security', 'idor', 'bugbounty'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 51,
    views_count: 10100,
    created_at: new Date(Date.now() - 40 * 3600000).toISOString(),
    profiles: {
      id: 'user29',
      username: 'api_hunter',
      display_name: 'API Hunter',
      points: 11230,
      reputation: 3340
    }
  },
  {
    id: 'v25',
    user_id: 'user30',
    type: 'feed' as const,
    category: 'vulnerability',
    title: 'Terraform State 파일 노출 - AWS 인프라 전체 장악',
    content: 'S3 버킷에 잘못 저장된 Terraform state 파일을 통해 전체 AWS 인프라의 구조와 시크릿을 획득한 사례입니다. RDS 비밀번호, API 키, IAM 역할 정보 등이 평문으로 저장되어 있었으며, 이를 통해 프로덕션 환경 전체를 장악할 수 있었습니다. 안전한 state 관리 방법을 제시합니다.',
    tags: ['terraform', 'iac', 'aws', 'secrets', 'cloud-security'],
    status: 'open',
    is_pinned: false,
    likes_count: 1987,
    replies_count: 68,
    views_count: 14500,
    created_at: new Date(Date.now() - 42 * 3600000).toISOString(),
    profiles: {
      id: 'user30',
      username: 'iac_security',
      display_name: 'IaC Security',
      points: 10890,
      reputation: 3290
    }
  }
];